import React, { useState } from "react";
import { FileEarmarkExcel } from "react-bootstrap-icons";
import * as XLSX from "xlsx";
import "./Toolbar.css";
import apiService from "../../API/ApiService.js";
import { useLocation } from 'react-router-dom';

const Toolbar = ({ data, visibleColumns, filename, filters }) => {
  const location = useLocation();
  const { username } = location.state || {};
  const [showExportModal, setShowExportModal] = useState(false);

  const columnNameMapping = {
    realSerialNumber: "DS5_SN",
    globalStatus: "Status",
    raspberry_id: 'TESTER NAME',
    deviceSerialNumber: 'Mac@',
    job_id: 'JOB ID',
    receipt_date: 'RECEIPT DATE',
    symptome_description: 'symptome',
    grade: "GRADE"
  };

  const handleExcelExport = async (exportAllData) => {
    let dataToExport = [];
  
    if (exportAllData) {
      try {
        const trimmedUsername = username?.trim() || '';
        let apiEndpoint = '/getDataALL';
  
        const params = {
          username: trimmedUsername,
          device: filters.device,
          raspberry: filters.raspberry,
          status: filters.status, // Ajout du filtre de statut
          date: filters.dateRange || [],
          timeStart: filters.timeRange?.start,
          timeEnd: filters.timeRange?.end,
        };
  
        const response = await apiService.get(apiEndpoint, { params });
  
        if (response.data && Array.isArray(response.data.data)) {
          dataToExport = response.data.data;
        }
      } catch (error) {
        console.error('Export error:', error);
      } 
    } else {
      dataToExport = data.map(row => {
        const filteredRow = {};
        visibleColumns.forEach(column => {
          if (row[column] !== undefined) {
            filteredRow[column] = row[column];
          }
        });
        return filteredRow;
      });
    }
  
    const renamedData = dataToExport.map(row => {
      const newRow = {};
      for (const key in row) {
        newRow[columnNameMapping[key] || key] = row[key];
      }
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(renamedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  return (
    <div className="toolbar-container">
      <button onClick={() => setShowExportModal(true)} className="excel-export">
        <FileEarmarkExcel size={20} className="excel-icon" />
        <span>Export Excel</span>
      </button>

      {showExportModal && (
        <div className="export-modal">
          <div className="export-modal-content">
            <h3>Choose Export Option</h3>
            <button onClick={() => { handleExcelExport(true); setShowExportModal(false); }}>
              Export All Data 
            </button>
            <button onClick={() => { handleExcelExport(false); setShowExportModal(false); }}>
              Export Only Final Status Test
            </button>
            <button onClick={() => setShowExportModal(false)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Toolbar;